import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { NewInboxStepsProvider } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'

const NewInboxProviderLayoutContent = observer(() => {
  return <Outlet />
})

export const NewInboxProviderLayout = () => {
  return (
    <NewInboxStepsProvider>
      <NewInboxProviderLayoutContent />
    </NewInboxStepsProvider>
  )
}
